import { Frame } from "@/models/frame";

export class Layer extends Frame {
	private _name: string;
	public color: string = "#313134";
	readonly type: string;

	constructor(id: number, name?: string) {
		super(id);
		this.name = name || `layer${this.id}`;
		this.type = "Layer";
	}

	get name(): string {
		return this._name;
	}

	set name(name: string) {
		this._name = name;
		const tableElement = document.getElementById(`item-${this.id}`);
		if (tableElement) {
			const headerElement = tableElement.querySelector(".eer-layer-header");
			if (headerElement) {
				headerElement.textContent = this._name;
			}
		}
	}

	placeNewItem(
		top: number,
		left: number,
		workspaceEl: HTMLElement,
		width?: number,
		height?: number,
	) {
		const itemElement = super.createNewItem(top, left, width, height);

		const layerElement = this.layerTemplate(itemElement);

		// Append the layer element to the workspace
		workspaceEl.appendChild(layerElement);

		const workspaceRect = workspaceEl.getBoundingClientRect();
		this.workspaceOverflowCheck(workspaceRect, layerElement);
		this.activeItemClear();
	}

	private layerTemplate(layerElement: HTMLElement): HTMLElement {
		layerElement.classList.add("eer-layer");
		layerElement.style.zIndex = "9";

		// Create the header element
		const headerElement = document.createElement("div");
		headerElement.classList.add("item-header");
		headerElement.classList.add("eer-layer-header");

		// Add some text or content to the header
		headerElement.textContent = this.name;

		// Append the header to the layer element
		layerElement.appendChild(headerElement);

		return layerElement;
	}

	public changeColor(color: string) {
		this.color = color;
		const layerElement = document.getElementById(`item-${this.id}`);
		if (layerElement) {
			layerElement.style.backgroundColor = color;
		}
	}
}
